/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

'use strict';

module.exports = '15.7.0';



/*****************
 ** WEBPACK FOOTER
 ** ./~/react/lib/ReactVersion.js
 ** module id = 392
 ** module chunks = 0
 **/